import axios from 'axios';

let capture = true;
let updateWeightInterval;

const updateTicketAddresses = async () => {
  try {
    const res = await axios.get('/contact_addresses', {
      params: { contact_id: $('#ticket_contact_id').val() },
    });
    const addresses = res.data;
    const addressSelect = $('#ticket_address');
    addressSelect.empty();
    $.each(addresses, function (_, addr) {
      addressSelect.append(new Option(addr));
    });
    addressSelect.trigger('change');
  } catch (error) {
    console.log(error);
  }
};

const calculateNetWeigth = () => {
  let diff;
  let net;
  if ($('#ticket_type').text().includes('Recep')) {
    net = $('#incoming_weight').text() - $('#ticket_outgoing_weight').val();
    diff = net - $('#provider_weight').text();
  } else {
    net = $('#ticket_outgoing_weight').val() - $('#incoming_weight').text();
    diff = net - $('#provider_weight').text();
  }
  if (!$('#ticket_outgoing_weight').val()) {
    // Check for "", null, undefined, NaN
    net = '--';
    diff = '--';
  } else {
    net = net.toFixed(2);
    diff = diff.toFixed(2);
  }
  $('#net_weight').html(net);
  $('#weight_difference').html(diff);
};

// Get romana server IP from Settings and selected romana port
// and update incoming/outgoing weight
const updateWeight = () => {
  const newTicket = document.querySelector('.js-new-ticket');
  const closeTicket = document.querySelector('.js-close-ticket');
  const manualWeighEnabled = newTicket
    ? $('#manual_incoming_weight').prop('checked')
    : $('#manual_outgoing_weight').prop('checked');

  let romanaServerIpType;
  if (newTicket) {
    romanaServerIpType = 1; // romana_server_ip_in
  } else if (closeTicket) {
    romanaServerIpType = 2; // romana_server_ip_out
  }

  const getWeight = async () => {
    try {
      // Get Romana server IP address
      const res1 = await axios.get('/romana_server_ip', {
        params: { type: romanaServerIpType },
      });
      const romanaServerIp = res1.data;
      if (!romanaServerIp) return;

      // Get weight from Romana server
      const res2 = await axios.get(
        `${romanaServerIp}/serial_weight/get_weight.json`
      );
      const weight = res2.data.weight ? res2.data.weight : res2.data;

      // Update incoming/outgoing weight in real time
      if (newTicket) {
        $('#ticket_incoming_weight').val(weight);
      } else {
        $('#ticket_outgoing_weight').val(weight);
        calculateNetWeigth();
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (capture && !manualWeighEnabled) {
    getWeight();
  }
};

const captureWeight = () => {
  if (capture) {
    capture = false;
    $('#capture_weight_button').val('Capturado');
  } else {
    capture = true;
    $('#capture_weight_button').val('Capturar');
  }
  $('#capture_weight_button').toggleClass('btn-danger btn-success');
};

const saveWeight = () => {
  if (capture) {
    capture = false;
    $('#capture_weight_button').val('Capturado');
    $('#capture_weight_button').toggleClass('btn-danger btn-success');
    $('#ticket_outgoing_weight').val($('#saved_weight').text());
    calculateNetWeigth();
  }
};

const createNewDriver = () => {
  axios
    .post('/drivers.json', {
      name: $('#driver_name').val(),
      ci: $('#driver_ci').val(),
      phone_number: $('#driver_phone_number').val(),
      address: $('#driver_address').val(),
      frequent: $('#driver_frequent').is(':checked'),
    })
    .then(response => {
      const driver = response.data;
      const text = `${driver.ci} - ${driver.name}`;
      const driverSelect = $('#ticket_driver_id');
      driverSelect.empty();
      driverSelect.append(new Option(text, driver.id));
      driverSelect.trigger('change');
      $('#create-driver-modal').modal('hide');
      $('#new-driver-button').hide();
    })
    .catch(error => {
      const errors = error.response.data;
      $('#driver-form-errors').show();
      $('#driver-errors-list').html('');
      errors.forEach(function (err) {
        $('#driver-errors-list').append(`<li>${err}</li>`);
      });
    });
};

const createNewTruck = () => {
  axios
    .post('/trucks.json', {
      license_plate: $('#truck_license_plate').val(),
      transport_company_id: $('#truck_transport_company_id').val(),
      frequent: $('#truck_frequent').is(':checked'),
    })
    .then(response => {
      const truck = response.data;
      const text = `${truck.license_plate} - ${truck.transport_company.name}`;
      const truckSelect = $('#ticket_truck_id');
      truckSelect.empty();
      truckSelect.append(new Option(text, truck.id));
      truckSelect.trigger('change');
      $('#create-truck-modal').modal('hide');
      $('#new-truck-button').hide();
    })
    .catch(error => {
      const errors = error.response.data;
      $('#truck-form-errors').show();
      $('#truck-errors-list').html('');
      errors.forEach(function (err) {
        $('#truck-errors-list').append(`<li>${err}</li>`);
      });
    });
};

const createNewTransportCompany = () => {
  axios
    .post('/transport_companies.json', {
      name: $('#transport_company_name').val(),
      rif: $('#transport_company_rif').val(),
      phone_number: $('#transport_company_phone_number').val(),
      email: $('#transport_company_email').val(),
      address: $('#transport_company_address').val(),
      frequent: $('#transport_company_frequent').is(':checked'),
    })
    .then(response => {
      const transportCompany = response.data;
      const text = `${transportCompany.code} - ${transportCompany.name}`;
      const transportCompanySelect = $('#truck_transport_company_id');
      transportCompanySelect.empty();
      transportCompanySelect.append(new Option(text, transportCompany.id));
      transportCompanySelect.trigger('change');
      $('#new-transport-company-box-and-button').hide();
    })
    .catch(error => {
      const errors = error.response.data;
      $('#truck-form-errors').show();
      $('#truck-errors-list').html('');
      errors.forEach(function (err) {
        $('#truck-errors-list').append(`<li>${err}</li>`);
      });
    });
};

const createNewShip = () => {
  axios
    .post('/ships.json', {
      code: $('#ship_code').val(),
      description: $('#ship_description').val(),
    })
    .then(response => {
      const ship = response.data;
      const text = `${ship.code} - ${ship.description}`;
      const shipSelect = $('#ticket_ship_id');
      shipSelect.empty();
      shipSelect.append(new Option(text, ship.id));
      shipSelect.trigger('change');
      $('#create-ship-modal').modal('hide');
      $('#new-ship-button').hide();
    })
    .catch(error => {
      const errors = error.response.data;
      $('#ship-form-errors').show();
      $('#ship-errors-list').html('');
      errors.forEach(function (err) {
        $('#ship-errors-list').append(`<li>${err}</li>`);
      });
    });
};

document.addEventListener('turbolinks:load', function () {
  // Update addresses select after changing client
  $('#ticket_contact_id').on('change', updateTicketAddresses);
  // Hide/show data when creating new ticket and selecting ticket type and order type
  if ($('#ticket_ticket_type_dispatch').prop('checked')) {
    $('#only_reception_ticket_data, .js-ticket-ship-form').hide();
  }
  if ($('#ticket_ticket_order_no_order').prop('checked')) {
    $('#ticket_client_and_address, #ticket-data, #ticket-items-box').show();
  }
  if ($('#ticket_ticket_order_load_order').prop('checked')) {
    $('#load_order_select, #ticket-data').show();
    $('#ticket_client_and_address').hide();
  }
  if ($('#ticket_ticket_order_purchase_order').prop('checked')) {
    $('#purchase_order_select, #ticket-data').show();
    $('#ticket_client_and_address').hide();
  }
  // Hide/show provider weight, document number and ship depeding on selected ticket type
  $('#ticket_ticket_type_dispatch').on('click', function () {
    $('#only_reception_ticket_data, .js-ticket-ship-form').hide();
    $('#ticket_provider_weight').val('');
    $('#ticket_provider_document_number').val('');
    $('#ticket_ship_id').val(null).trigger('change');
  });
  $('#ticket_ticket_type_reception').on('click', function () {
    $('#only_reception_ticket_data, .js-ticket-ship-form').show();
  });

  // Hide/show data depending on selected order type (none, purchase order, load order)
  $('#ticket_ticket_order_load_order').on('click', function () {
    $('#load_order_select, #ticket-data').show();
    $(
      '#purchase_order_select, #ticket_client_and_address, #ticket-items-box'
    ).hide();
    $('#ticket_purchase_order_id').val(null).trigger('change');
  });
  $('#ticket_ticket_order_purchase_order').on('click', function () {
    $('#purchase_order_select, #ticket-data').show();
    $(
      '#load_order_select, #ticket_client_and_address, #ticket-items-box'
    ).hide();
    $('#ticket_load_order_id').val(null).trigger('change');
  });
  $('#ticket_ticket_order_no_order').on('click', function () {
    $('#purchase_order_select, #load_order_select').hide();
    $('#ticket_client_and_address, #ticket-data, #ticket-items-box').show();
    $('#ticket_purchase_order_id, #ticket_load_order_id')
      .val(null)
      .trigger('change');
  });

  // Enable editing incoming/outgoing weight fields when manual incoming/outgoing weight is checked
  $('#manual_incoming_weight').on('change', function () {
    $('#ticket_incoming_weight').prop('readOnly', !this.checked);
  });
  $('#manual_outgoing_weight').on('change', function () {
    $('#ticket_outgoing_weight').prop('readOnly', !this.checked);
  });

  // Create new driver via AJAX
  $('#create-driver-modal').on('show.bs.modal', function () {
    $('#create-driver-button').on('click', function (e) {
      e.preventDefault();
      createNewDriver();
    });
  });
  $('#new-transport-company-button').on('click', function () {
    $('#new-transport-company-box').toggle();
  });

  // Create new truck via AJAX
  $('#create-truck-modal').on('show.bs.modal', function () {
    $('#create-transport-company-button').on('click', function (e) {
      e.preventDefault();
      createNewTransportCompany();
    });
    $('#create-truck-button').on('click', function (e) {
      e.preventDefault();
      createNewTruck();
    });
  });

  // Create new ship via AJAX
  $('#create-ship-modal').on('show.bs.modal', function () {
    $('#create-ship-button').on('click', function (e) {
      e.preventDefault();
      createNewShip();
    });
  });

  /* Update incoming/outgoing weight, net weight and weight difference every second
   *  only in new or close action
   */
  if (
    document.querySelector('.js-new-ticket') ||
    document.querySelector('.js-close-ticket')
  ) {
    updateWeightInterval = setInterval(updateWeight, 1000);
  }

  // Show net weight and weight difference on keyup
  $('#ticket_outgoing_weight').on('keyup', calculateNetWeigth);
  // Toggle capture_weight_button styling
  $('#capture_weight_button').on('click', captureWeight);
  // Toggle capture_weight_button styling and calculate net weigth from saved weight
  $('#use_saved_weight_button').on('click', saveWeight);

  /* Update romana_port_1 value in Settings
     and set it in the web browser's local storage to keep value on reload */
  $('#romana_port_1').on('change', function () {
    if ($('#romana_port_1').prop('checked')) {
      localStorage.setItem('romana_port_1_checked', 'true');
      axios.put('/settings/1/update_romana_in_use.json', {
        romana_port_1: true,
      });
    } else {
      localStorage.setItem('romana_port_1_checked', 'false');
      axios.put('/settings/1/update_romana_in_use.json', {
        romana_port_1: false,
      });
    }
    window.location.reload();
  });
  if ($('#romana_port_1') !== null) {
    const romanaPort1 = $('#romana_port_1');
    const romanaPort1Checked = localStorage.getItem('romana_port_1_checked');
    if (romanaPort1Checked === 'true') {
      romanaPort1.prop('checked', true);
    } else {
      romanaPort1.prop('checked', false);
    }
  }

  /* Update romana_port_2 value in Settings
     and set it in the web browser's local storage to keep value on reload */
  $('#romana_port_2').on('change', function () {
    if ($('#romana_port_2').prop('checked')) {
      localStorage.setItem('romana_port_2_checked', 'true');
      axios.put('/settings/1/update_romana_in_use.json', {
        romana_port_2: true,
      });
    } else {
      localStorage.setItem('romana_port_2_checked', 'false');
      axios.put('/settings/1/update_romana_in_use.json', {
        romana_port_2: false,
      });
    }
    window.location.reload();
  });
  if ($('#romana_port_2') !== null) {
    const romanaPort2 = $('#romana_port_2');
    const romanaPort2Checked = localStorage.getItem('romana_port_2_checked');
    if (romanaPort2Checked === 'true') {
      romanaPort2.prop('checked', true);
    } else {
      romanaPort2.prop('checked', false);
    }
  }
});

// setInterval is not torn down between Turbolinks page loads
// so it must be cleared manually with clearInterval()
document.addEventListener('turbolinks:before-render', function () {
  clearInterval(updateWeightInterval);
});
